// 私訊本文一律當純文字：回傳片段陣列，由 template 用 {{ }} 與 <a :href> 渲染。
// 刻意不回傳 HTML 字串、也不要在顯示端改回 v-html：訊息是瀏覽器 SDK 直送 Twilio，
// 伺服器碰不到，內容完全不可信，字串拼 HTML 再 escape 會讓 &quot; 之類被網址路徑吃進 href。
// 網域 label 限 63 字元、最多 10 層、TLD 2～24 字元（DNS 本來的上限）：沒有長度上限時，
// `a-a-a-…` 這種輸入會二次方回溯，一則 32KB 的訊息就能讓收訊方的分頁卡住一秒以上。
const URL_REGEX = /\b((https?:\/\/)?((?:[a-zA-Z0-9_-]{1,63}\.){1,10}[a-zA-Z]{2,24})(:[0-9]{1,5})?(\/[^\s]*)?)\b/g;
const HTTP_PROTOCOL = /^https?:\/\//i;

export function linkifyMessage(message) {
  if (!message) return [];

  const text = String(message);
  const parts = [];
  let cursor = 0;

  for (const match of text.matchAll(URL_REGEX)) {
    const url = match[0];
    // 只接受 http(s)；沒有協定的網域補 http://（現有行為）
    const href = HTTP_PROTOCOL.test(url) ? url : `http://${url}`;

    if (match.index > cursor) {
      parts.push({ type: "text", text: text.slice(cursor, match.index) });
    }
    parts.push({ type: "link", text: url, href });
    cursor = match.index + url.length;
  }

  if (cursor < text.length) {
    parts.push({ type: "text", text: text.slice(cursor) });
  }

  return parts;
}
